<template>
  <div class="flex flex-row bgc-white" style="user-select: none;">
    <grid-row-index
      ref="rowIndex"
      :rows="rows"
      :selected-part="isSelectedPart"
      class="flex-auto"
      @click-header-cell="selectAll"
      @click-body-cell="selectRow"
    />
    <div class="flex-fill flex flex-column" style="position: relative;">
      <grid-column-index
        ref="columnIndex"
        :columns="columns"
        :selected-part="isSelectedPart"
        class="flex-auto column-index"
        @click-cell="selectColumn"
      />
      <grid-table-wrapper
        :columns="columns"
        class="border-right border-bottom border-no-left border-no-top"
        ref="controller"
        style="overflow: auto;"
        @scroll.native="handleBodyScroll"
      >
        <grid-body-content
          ref="body"
          :readonly="readonly"
          :columns="columns"
          :rows="rows"
          :line-height-method="() => '30px'"
          :selected-range-method="selectedRangeMethod"
          class="flex-fill grid-body"
          style="position: relative;"
          @selected-range="handleSelectedRange"
          @mouse-down-cell="handleMouseDownCell"
          @change-value="handleChangeValue"
          ><slot name="body-cell"
        /></grid-body-content>
      </grid-table-wrapper>
    </div>
  </div>
</template>
<script>
import {
  computeColumns,
  createColumns,
} from "@/components/grid/libs/GridUtils.ts";
import GridColumnIndex from "@/components/grid/ColumnIndex";
import { computeRows, mergeRows } from "@/components/grid/libs/GridUtils.ts";
import GridRowIndex from "@/components/grid/RowIndex";
import { CellPosition } from "@/components/excel/schema/BaseSchema.ts";
import { IndexCache } from "@/components/grid/libs/IndexCache.ts";
import { CellCache } from "@/components/grid/libs/CellCache.ts";
import { CellRange } from "@/components/excel/schema/BaseSchema";
import GridBodyContent from "@/components/grid/BodyContent";
import GridTableWrapper from "@/components/grid/TableWrapper";

export default {
  name: "grid-excel",
  components: {
    GridTableWrapper,
    GridBodyContent,
    GridColumnIndex,
    GridRowIndex,
  },
  props: {
    minColumns: {
      type: Number,
      default: 15,
    },
    minRows: {
      type: Number,
      default: 20,
    },
    minEmptyColumns: {
      type: Number,
      default: 1,
    },
    minEmptyRows: {
      type: Number,
      default: 1,
    },
    styleMethod: {
      type: Function,
    },
    cells: {
      type: Array,
    },
    defaultEditor: {
      type: Object,
    },
    readonly: Boolean
  },
  data() {
    const defaultCell = new CellPosition(1, 1);
    return {
      defaultCell,
      cache: {
        row: new IndexCache(defaultCell.rowIndex),
        column: new IndexCache(defaultCell.columnIndex),
        cell: new CellCache(defaultCell),
      },
      selected: {
        row: {
          indexes: [],
          ranges: [],
        },
        column: {
          indexes: [],
          ranges: [],
        },
        cell: {
          positions: [],
          ranges: [],
        },
      },
      selectedRange: {
        range: { left: 1, right: 1, top: 1, bottom: 1 },
        start: new CellPosition(1, 1),
        end: new CellPosition(1, 1),
      },
      selectedColumn: {
        single: null,
        multi: [],
        range: { start: null, end: null },
      },
      selectedRow: {
        single: null,
        multi: [],
        range: { start: null, end: null },
      },
      columns: [],
      rows: [],
    };
  },
  computed: {
    mergedRows() {
      const { cells, minRows, minEmptyRows, columns, defaultEditor } = this;
      console.log(defaultEditor);
      const size = computeRows(cells, minRows, minEmptyRows);
      return mergeRows(cells, size, columns, defaultEditor);
    },
    mergedColumns() {
      const { cells, minColumns, minEmptyColumns } = this.$props;
      const cols = computeColumns(cells, minColumns, minEmptyColumns);
      return createColumns(cols);
    },
  },
  watch: {
    mergedRows() {
      this.refreshCache({ row: true });
    },
    mergedColumns() {
      this.refreshCache({ column: true });
    },
  },
  mounted() {
    this.refreshCache({ row: true, column: true });
  },
  methods: {
    assembleColumns() {
      const { mergedColumns } = this;
      if (!this.cache.column.hasSelected) {
        return mergedColumns;
      }
      console.log("触发列重新计算");
      return mergedColumns.map((it) => {
        const { index } = it;
        const selected = this.cache.column.isSelected(index);
        if (selected) {
          return { ...it, selected: true };
        }
        return it;
      });
    },
    assembleRows() {
      const { mergedRows } = this;
      if (!this.cache.row.hasSelected) {
        return mergedRows;
      }
      return mergedRows.map((it) => {
        const { index } = it;
        const selected = this.cache.row.isSelected(index);
        if (selected) {
          return { ...it, selected: true };
        }
        return it;
      });
    },
    handleBodyScroll(event) {
      const { target } = event;
      if (target) {
        const { scrollTop, scrollLeft } = target;
        const { rowIndex, columnIndex } = this.$refs;
        if (rowIndex) {
          rowIndex.scrollTo({ top: scrollTop });
        }
        if (columnIndex) {
          columnIndex.scrollTo({ left: scrollLeft });
        }
      }
    },
    mergeSelectedCells() {},
    cancelMergedCell() {},
    deleteSelected() {},
    insertRow() {},
    insertColumn() {},
    insertCell() {},
    selectAll() {
      this.selectedColumn = {
        single: null,
        multi: [],
        range: { start: 1, end: null },
      };
      this.selectedRow = {
        single: null,
        multi: [],
        range: { start: 1, end: null },
      };
      this.selectCell({ rowIndex: 1, columnIndex: 1 });
    },
    selectColumnFirstCell(columnIndex) {
      this.selectCell({ rowIndex: 1, columnIndex });
    },
    selectRowFirstCell(rowIndex) {
      this.selectCell({ rowIndex, columnIndex: 1 });
    },
    selectCell({ rowIndex, columnIndex }, multi) {
      const position = new CellPosition(rowIndex, columnIndex);
      const option = {
        cell: position,
        isMulti: multi,
        isRange: false,
      };
      this.cache.cell.select(option);
      this.refreshCache({ cell: true });
      const { body } = this.$refs;
      if (body) {
        body.selectCell({ rowIndex, columnIndex });
      }
    },
    selectRange({ start, end }, multi) {
      const range = new CellRange(start, end);
      if (multi) {
        this.cache.cell.selectMultiRange(range);
      } else {
        // 非多选 为了清除所有的选中 调用 selectSingle
        this.cache.cell.selectRange(range);
      }
      this.refreshCache({ cell: true });
    },
    selectColumn({ column, multi: isMulti, range: isRange }) {
      if (!isMulti && !isRange) {
        this.cancelSelectedRow();
      }
      const option = { index: column.index, isMulti, isRange };
      this.cache.column.select(option);
      this.selectColumnFirstCell(this.cache.column.currentIndex);
      this.refreshCache({ column: true });
    },
    selectRow({ row, multi: isMulti, range: isRange }) {
      if (!isMulti && !isRange) {
        this.cancelSelectedColumn();
      }
      const option = { index: row.index, isMulti, isRange };
      this.cache.row.select(option);
      if (!isRange) {
        this.selectRowFirstCell(this.cache.row.currentIndex);
      }
      this.refreshCache({ row: true });
    },
    handleSelectedRange(value, event) {
      console.log(event);
      this.selectedRange = value;
      if (event) {
        const { ctrlKey, shiftKey } = event;
        const { start, end } = value;
        if (shiftKey) {
          const start = this.cache.cell.lastSelected;
          this.selectRange({ start, end }, false);
        } else if (ctrlKey) {
          this.selectRange({ start, end }, true);
        } else {
          this.selectRange({ start, end });
        }
      }
    },
    handleMouseDownCell(params, event) {
      const { ctrlKey, shiftKey } = event;
      const { rowIndex, columnIndex } = params;
      console.log(params, event);
      const position = new CellPosition(rowIndex, columnIndex);
      if (shiftKey) {
        // 进入区域选择模式  不修改 lastSelected
        const start = this.cache.cell.lastSelected;
        const end = position;
        this.selectRange({ start, end });
      } else if (ctrlKey) {
        // 进入多选模式
        this.selectCell(position, true);
      } else {
        this.cancelSelectedColumn();
        this.cancelSelectedRow();
        this.selectCell(position);
      }
    },
    cancelSelectedColumn() {
      this.cache.column.clear();
      this.refreshCache({ column: true });
      const { single, multi, range } = this.selectedColumn;
      const { start, end } = range;
      if (single || multi.length || start || end) {
        this.selectedColumn = {
          single: null,
          multi: [],
          range: { start: null, end: null },
        };
      }
    },
    cancelSelectedRow() {
      this.cache.row.clear();
      this.refreshCache({ row: true });
      const { single, multi, range } = this.selectedRow;
      const { start, end } = range;
      if (single || multi.length || start || end) {
        this.selectedRow = {
          single: null,
          multi: [],
          range: { start: null, end: null },
        };
      }
    },
    refreshCache({ row, column, cell }) {
      console.log("收到刷新请求", row, column, cell);
      if (cell) {
        //想办法更新行和列索引样式的刷新
        const position = this.cache.cell.lastSelected;
        const { row: rowCache, column: columnCache } = this.cache;
        if (rowCache.lastUnselected !== position.rowIndex) {
          rowCache.lastUnselected = position.rowIndex;
        }
        if (columnCache.lastUnselected !== position.columnIndex) {
          columnCache.lastUnselected = position.columnIndex;
        }
      }
      if (row) {
        //想办法更新行索引样式的刷新
        this.rows = this.assembleRows();
      }
      if (column) {
        //想办法更新列索引样式的刷新
        this.columns = this.assembleColumns();
      }
      const event = "cell-selected";
      if (this.$listeners[event]) {
        const payload = {
          cell: this.cache.cell.lastSelected,
          isSingle: this.cache.cell.isSelectedSingle,
        };
        this.$emit(event, payload);
      }
    },
    selectedRangeMethod({ row, column }) {
      const cell = new CellPosition(row.index, column.index);
      const range = this.cache.cell.findRange(cell);
      if (range) {
        return range;
      }
      if (this.cache.cell.isSelected(cell)) {
        return new CellRange(cell, cell);
      }
    },
    isSelectedPart({ row, column }) {
      if (row && column) {
        const cell = new CellPosition(row.index, column.index);
        return this.cache.cell.isSelected(cell);
      }
      if (row) {
        return this.cache.cell.isExistSelectedCellOnRow(row.index);
      }
      if (column) {
        return this.cache.cell.isExistSelectedCellOnColumn(column.index);
      }
    },
    handleChangeValue(payload) {
      this.$emit("change-value", payload);
    },
  },
};
</script>
<style scoped>
.grid-excel-index {
  background-color: #f8f8f9;
}
</style>
